import { render, staticRenderFns } from "./CustomerCorporateSubscriptionRenewal.vue?vue&type=template&id=b5e0f2f0&scoped=true"
import script from "./CustomerCorporateSubscriptionRenewal.vue?vue&type=script&lang=js"
export * from "./CustomerCorporateSubscriptionRenewal.vue?vue&type=script&lang=js"
import style0 from "./CustomerCorporateSubscriptionRenewal.vue?vue&type=style&index=0&id=b5e0f2f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e0f2f0",
  null
  
)

export default component.exports